import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { FeatureManagementStateClass } from './interfaces/featureManagementStateClass';
const initialState: FeatureManagementStateClass = {
    isLoading: false,
    status: 'idle',
    featureManagementList: [],
    featureList:[],
    selectedRecord: {},
    isReload : false,
    isUpdateData: true
}
interface IThunkApi {
    state: {
        featureManagement: FeatureManagementStateClass;
    }
}
export const getFeatureManagementAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'featureManagement/FeatureManagement',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/FeatureManagement', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const addFeatureManagementAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'featureManagement/addFeatureManagementAsync',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/FeatureManagement/UpdateFeature', 'PUT', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
   
  
  
export const featureManagementSlice = createSlice({
    name: 'featureManagement',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
       
        setValuesfeatureManagementList: (state, action) => {
        const {value,FieldName} = action.payload; 
        const newArray = [...state.featureManagementList];
        const currentindex = state.featureManagementList.findIndex((item : any) => item.SystemFeatureId.toUpperCase() == value)
        if (currentindex === -1) {
        // Create a new item to add to the array
        const newItem = {AccountId: 0, SystemFeatureId: value , AccountFeatureId: '00000000-0000-0000-0000-000000000000',  isSelected: 1};
        // Add the new item to the copied array
        newArray.push(newItem);
        }else {
        // Item exists, so remove it
        newArray.splice(currentindex, 1);
        }
        state.featureManagementList = newArray;     
       
        },
        
        checkedState: (state, action) => {
            const currentindex = state.featureManagementList.findIndex((item: any) => item.SystemFeatureId.toUpperCase() == action.payload);
            const newArray = [...state.featureManagementList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            if (currentindex === -1) {
                const newItem = { AccountId: 0, SystemFeatureId: action.payload, AccountFeatureId: '00000000-0000-0000-0000-000000000000', isSelected: 1 };
                newArray.push(newItem);
            }
            state.featureManagementList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.featureManagementList.findIndex((item : any) => item.SystemFeatureId.toUpperCase() == action.payload)
            const newArray = [...state.featureManagementList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.featureManagementList = newArray;
        },
        updateFeature: (state, action) => {
            state.isUpdateData = action.payload
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getFeatureManagementAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getFeatureManagementAsync.fulfilled, (state, { payload }) => {
             
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.featureManagementList = [];
                    state.featureList = [];

                } else {
                    state.featureManagementList = payload.Data;
                    state.featureList = payload.Data;
                    state.featureManagementList.map((item: any) => {
                        
                        if(item.SystemFeatureId != -1){
                            item.isSelected = 1
                        }else{
                            item.isSelected = 0
                        }
                    });
                    // state.featureList.map((item: any) => {
                       
                    //     if(item.SystemFeatureId != -1){
                    //         item.isSelected = 1
                    //     }else{
                    //         item.isSelected = 0
                    //     }
                    // });
                }
                state.isReload = false;
                state.selectedRecord = {};
                state.isLoading = false;

                
            })

            .addCase(getFeatureManagementAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addFeatureManagementAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addFeatureManagementAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                state.isUpdateData = payload;
            })
            .addCase(addFeatureManagementAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
           
    }
})
export const {
    resetSelectedRecordObjectInState, setValuesfeatureManagementList,checkedState,unCheckedState, updateFeature
} = featureManagementSlice.actions
  export const featureManagementStateClass = (state: RootState) => state.featureManagement
 export default featureManagementSlice.reducer